import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка вакансий объектов
    async getLocationVacancies(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.locations) {
        data.locations.forEach(id => {
          params.append("locations[]", id);
        });
      }

      if (data.vacancies) {
        data.vacancies.forEach(id => {
          params.append("vacancies[]", id);
        });
      }

      return await this.get(`location_vacancies?${params.toString()}${sorting}`);
    },
    // Получение вакансий объекта по location id
    async getLocationVacancyByLocationId(locationId) {
      let params = new URLSearchParams();
      if (locationId != null) {
        params.set("location_id", locationId);
      }

      return await this.get(`location_vacancies?${params.toString()}`);
    },
    // Получение вакансий по id
    async getLocationVacancyById(vacancyId) {
      return await this.get(`location_vacancies/${vacancyId}`);
    },
    // Создание вакансий объекта
    async postLocationVacancy(data) {
      return await this.post(`location_vacancies`, data);
    },
    // Изменение вакансий объекта
    async putLocationVacancy(data) {
      return await this.put(`location_vacancies/${data.id}`, data);
    },
    // Удаление вакансий объекта
    async deleteLocationVacancy(data) {
      return await this.delete(`location_vacancies/${data.id}`, null);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/locationVacancies.js